import React from 'react';
import { Typography, Card } from 'antd';

const OverviewDashboard: React.FC = () => {
	return (
		<Card>
			<Typography.Title level={2} style={{ marginBottom: '24px' }}>
				Product Metrics Overview
			</Typography.Title>
			<Typography.Paragraph>
				Welcome to the Product Metrics Dashboard. This section will provide a high-level overview of
				key product metrics.
			</Typography.Paragraph>
		</Card>
	);
};

export default OverviewDashboard;
